import {
  AdvancedReportQueryRequestDto,
  AdvancedReportMetricRow
} from 'features/advanced-reports/advanced-reports.types';
import { MetricIdSeperator } from 'features/advanced-reports/constants/advanced-reports-metric-id-seperator';
import { CustomDataKeys } from 'common/constants/custom-data-keys';
import {
  AdvancedReportMetricResponse,
  InsightMetricResponse
} from '../advanced-report-api.types';
import { InsightQueryRequestDto } from 'features/insights/types/insights.types';

const sensitiveMetricTypeNames: string[] = [
  CustomDataKeys.KEYWORD,
  CustomDataKeys.LANDING_PAGE,
  CustomDataKeys.REFERRER,
  CustomDataKeys.UTM_CAMPAIGN,
  CustomDataKeys.UTM_MEDIUM,
  CustomDataKeys.UTM_CONTENT
];

export const createMetrics = (
  metric: AdvancedReportMetricResponse,
  request: AdvancedReportQueryRequestDto
): AdvancedReportMetricRow[] => {
  if (metric.metricTypeNames.length !== request.segmentRequests.length) {
    throw new Error(
      `The number of MetricTypeNames from the Query API does not match the number of SegmentRequests made. MetricTypeNames count: ${metric.metricTypeNames.length} - SegmentRequests count: ${request.segmentRequests.length}.`
    );
  }

  const metricRows = metric.metricTypeNames.map<AdvancedReportMetricRow>(
    (metricTypeName, metricIndex, metricTypeNames) => ({
      metricId: metricTypeNames
        .filter((_, index) => index <= metricIndex)
        .join(MetricIdSeperator),
      metricParentId: metricTypeNames
        .filter((_, index) => index < metricIndex)
        .join(MetricIdSeperator),
      rootAncestorId: metricTypeNames[0],
      metricTypeName,
      isMetricTypeNameSensitive: sensitiveMetricTypeNames.includes(
        request.segmentRequests[metricIndex].segmentCategory
      ),
      metricValue: metric.metricValue,
      depth: metricIndex
    })
  );

  return metricRows;
};

export const createInsightMetrics = (
  metric: InsightMetricResponse,
  request: InsightQueryRequestDto
): AdvancedReportMetricRow[] => {
  if (metric.metricTypeNames.length !== request.segmentRequests.length) {
    throw new Error(
      `The number of MetricTypeNames from the Query API does not match the number of SegmentRequests made. MetricTypeNames count: ${metric.metricTypeNames.length} - SegmentRequests count: ${request.segmentRequests.length}.`
    );
  }

  const metricRows = metric.metricTypeNames.map<AdvancedReportMetricRow>(
    (metricTypeName, metricIndex, metricTypeNames) => ({
      metricId: metricTypeNames
        .filter((_, index) => index <= metricIndex)
        .join(MetricIdSeperator),
      metricParentId: metricTypeNames
        .filter((_, index) => index < metricIndex)
        .join(MetricIdSeperator),
      rootAncestorId: metricTypeNames[0],
      metricTypeName,
      isMetricTypeNameSensitive: sensitiveMetricTypeNames.includes(
        request.segmentRequests[metricIndex].segmentCategory
      ),
      metricValue: metric.metricValue,
      depth: metricIndex
    })
  );

  return metricRows;
};
